module.exports = __webpack_public_path__ + "img/42ne.67da6ff6.svg";